import { render, staticRenderFns } from "./pdialogue.vue?vue&type=template&id=1304a492&scoped=true&"
import script from "./pdialogue.vue?vue&type=script&lang=js&"
export * from "./pdialogue.vue?vue&type=script&lang=js&"
import style0 from "./pdialogue.vue?vue&type=style&index=0&id=1304a492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304a492",
  null
  
)

export default component.exports